// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1oNES","row":"ProcedureTreatmentSummary_row__JfZff"};